'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.fonts.list', [])
  .controller('FontsListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/fonts/list/index.js